/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The InlineResponse2005 model module.
 * @module model/InlineResponse2005
 * @version v0.3
 */
export default class InlineResponse2005 {
  /**
   * Constructs a new <code>InlineResponse2005</code>.
   * @alias module:model/InlineResponse2005
   * @class
   * @param sessionToken {String}
   * @param termsRequired {Boolean}
   */
  constructor(sessionToken, termsRequired) {
    this.sessionToken = sessionToken;
    this.termsRequired = termsRequired;
  }

  /**
   * Constructs a <code>InlineResponse2005</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse2005} obj Optional instance to populate.
   * @return {module:model/InlineResponse2005} The populated <code>InlineResponse2005</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse2005();
      if (data.hasOwnProperty('session_token'))
        obj.sessionToken = ApiClient.convertToType(data['session_token'], 'String');
      if (data.hasOwnProperty('terms_required'))
        obj.termsRequired = ApiClient.convertToType(data['terms_required'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} sessionToken
 */
InlineResponse2005.prototype.sessionToken = undefined;

/**
 * @member {Boolean} termsRequired
 */
InlineResponse2005.prototype.termsRequired = undefined;
